<template>
  <div>
    <div class="WRAPPER">
      <div
          v-for="n in max"
          :key="n">
        <div
            :style="{ fontSize: barSize }"
            :selenium="`rating-bar-${n}`"
            class="BAR">
          <img
              :src="(isMainHeader) ? barUnFilledLargeImage : barUnFilledImage"
              v-bind:class="{ 'ROUNDED-LEFT-CORNER' : n===1,
                              'ROUNDED-RIGHT-CORNER': n===5,
                              'BAR-CORNER': isMainHeader,
                              'BAR-MIDDLE': n!==1 && n!==5  }" >
        </div>
        <div class="FILLED">
          <div
              :style="{ width: filledWidth(n), fontSize: barSize }"
              class="BAR">
            <img
                :src="(isMainHeader) ? barFilledLargeImage : barFilledImage"
                v-bind:class="{ 'ROUNDED-LEFT-CORNER' : n===1,
                                'ROUNDED-RIGHT-CORNER': n===5,
                                'BAR-CORNER': isMainHeader,
                                'BAR-MIDDLE': n!==1 && n!==5  }" >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const BAR_UNFILLED_IMAGE = require('./assets/barUnfilled.svg');
const BAR_FILLED_IMAGE = require('./assets/barFilled.svg');
const BAR_UNFILLED_LARGE_IMAGE = require('./assets/barUnfilledLarge.svg');
const BAR_FILLED_LARGE_IMAGE = require('./assets/barFilledLarge.svg');

export default {
  name: 'responsive-rating-bars',
  props: {
    value: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      default: 5,
    },
    barSize: {
      type: String,
      default: '16px',
    },
    isMainHeader: {
      type: Boolean,
      required: false,
    },
  },
  data () {
    return {
      barUnFilledImage: BAR_UNFILLED_IMAGE,
      barFilledImage: BAR_FILLED_IMAGE,
      barUnFilledLargeImage: BAR_UNFILLED_LARGE_IMAGE,
      barFilledLargeImage: BAR_FILLED_LARGE_IMAGE,
    };
  },
  methods: {
    filledWidth (index) {
      if ((this.value - index) >= 0) {
        return '100%';
      }
      return Math.abs(this.value - index) < 1 ? `${100 * ((Math.ceil(this.value * 2) / 2) - Math.floor(this.value))}%` : '0';
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools.scss";
    .WRAPPER {
        display: flex;
        position: relative;
        &>div {
            margin-right: auto;
        }
    }
    .BAR {
        transition: color 100ms ease;
        & + & {
            padding-left: 0.5em;
        }
    }
    .FILLED {
        position: absolute;
        top: 0;
        pointer-events: none;
        &>div {
            overflow: hidden;
        }
    }
    .ROUNDED-LEFT-CORNER{
     border-top-left-radius: 50px;
     border-bottom-left-radius: 50px;
    }
    .ROUNDED-RIGHT-CORNER{
     border-top-right-radius:50px;
     border-bottom-right-radius:50px;
    }
    .BAR-MIDDLE{
      padding-left: 0.2em;
      padding-right: 0.2em;
      height: 7px;
      @include mobile-only() {
      width: 40px;
      }
    }
    .BAR-CORNER{
      height: 7px;
      @include mobile-only() {
      width: 40px;
      }
    }

</style>
